import React from 'react';
import { CheckCircleIcon } from 'lucide-react';
interface BenefitSectionProps {
  number?: string; // Made optional
  title: string;
  content: string;
  description: string;
  takeaway: string;
  imageUrl: string;
  imagePosition: 'left' | 'right'; // Keeping this prop for backward compatibility
  extraInfo?: string;
}
export const BenefitSection: React.FC<BenefitSectionProps> = ({
  number,
  title,
  content,
  description,
  takeaway,
  imageUrl,
  imagePosition,
  // Still accepting this prop but not using it for desktop layout
  extraInfo
}) => {
  const textContent = <div className="md:flex-[0_0_50%]
 flex flex-col justify-center" data-id="element-8">
      <div className="flex items-start mb-4" data-id="element-9">
        <div className="text-green-600 mr-2 mt-1" data-id="element-10">✅</div>
        <div data-id="element-11">
          <h2 className="text-[21px] font-bold text-gray-800" data-id="element-12">{title}</h2>
        </div>
      </div>
      <p className="text-gray-700 mb-4 text-[19px]" data-id="element-13">{content}</p>
      <p className="text-gray-700 mb-4 text-[19px]" data-id="element-14">{description}</p>
      {extraInfo && <p className="text-gray-700 mb-4 text-[19px]" data-id="element-15">{extraInfo}</p>}
      <p className="text-gray-800 font-medium italic text-[19px]" data-id="element-16">{takeaway}</p>
    </div>;
  const imageContent = <div className="md:w-1/2 flex justify-center items-center" data-id="element-17">
      <img src={imageUrl} alt={title} className="rounded-lg shadow-xl w-full h-auto" data-id="element-18" />
    </div>;
  return <section className="py-12 md:py-16" data-id="element-19">
      <div className="flex flex-col md:flex-row gap-8" data-id="element-20">
        {/* On mobile, always show text first */}
        <div className="md:hidden" data-id="element-21">{textContent}</div>
        {/* On desktop, always show text on left and image on right, regardless of imagePosition prop */}
        <div className="hidden md:block" data-id="element-22">{textContent}</div>
        <div className="hidden md:block" data-id="element-23">{imageContent}</div>
        {/* On mobile, show image after text */}
        <div className="md:hidden" data-id="element-24">{imageContent}</div>
      </div>
    </section>;
};